<div class="situ-reels-page">
  <div class="page-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.xs="column" fxLayoutGap.xs="12px">
    <div>
      <h1 class="page-title">SituReels</h1>
      <div class="page-subtitle">Curate prospect-facing home showcases. Share one link, the prospect switches between every theme you put in the reel.</div>
    </div>
    <button mat-flat-button color="primary" (click)="openCreate()">
      <mat-icon>add</mat-icon>
      New SituReel
    </button>
  </div>

  <div *ngIf="loading" class="loading-row" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="reels.length === 0" class="empty-state">
      <mat-icon>video_library</mat-icon>
      <h3>No SituReels yet</h3>
      <p>Spin up a reel to bundle a home's themes — or a mix of panoramas, facades, plans, products and renders — into one shareable link.</p>
      <button mat-flat-button color="primary" (click)="openCreate()">
        <mat-icon>add</mat-icon>
        New SituReel
      </button>
    </div>

    <div *ngIf="reels.length > 0" class="reels-grid">
      <div *ngFor="let reel of reels; trackBy: trackById" class="reel-card">
        <div class="reel-hero">
          <ng-container *ngIf="defaultItem(reel) as def">
            <img *ngIf="!thumbnailFailed[def.artifactId]"
                 [src]="getItemThumb(def)"
                 [alt]="reel.name"
                 loading="lazy"
                 (error)="onThumbError(def)">
            <div *ngIf="thumbnailFailed[def.artifactId]" class="reel-hero-fallback">
              <mat-icon>{{ getFallbackIcon(def) }}</mat-icon>
            </div>
          </ng-container>
          <div class="reel-hero-overlay">
            <div class="reel-item-count">
              <mat-icon>collections</mat-icon>
              {{ reel.items.length }} {{ reel.items.length === 1 ? 'item' : 'items' }}
            </div>
          </div>
        </div>

        <div class="reel-body">
          <div class="reel-name" [matTooltip]="reel.name">{{ reel.name }}</div>
          <div class="reel-description" *ngIf="reel.description" [matTooltip]="reel.description">{{ reel.description }}</div>

          <div class="reel-mini-thumbs" *ngIf="otherItems(reel).length > 0">
            <div *ngFor="let item of visibleOtherItems(reel)" class="mini-thumb" [matTooltip]="item.label">
              <img *ngIf="!thumbnailFailed[item.artifactId]"
                   [src]="getItemThumb(item)"
                   [alt]="item.label"
                   loading="lazy"
                   (error)="onThumbError(item)">
              <div *ngIf="thumbnailFailed[item.artifactId]" class="mini-thumb-fallback">
                <mat-icon>{{ getFallbackIcon(item) }}</mat-icon>
              </div>
            </div>
            <div *ngIf="hiddenOtherCount(reel) > 0" class="mini-thumb mini-thumb-more">
              +{{ hiddenOtherCount(reel) }}
            </div>
          </div>

          <div class="reel-share">
            <mat-icon class="share-icon">link</mat-icon>
            <span class="share-url-text" [matTooltip]="shareUrl(reel)">{{ shareUrl(reel) }}</span>
            <button mat-icon-button matTooltip="Copy share URL" (click)="copyShareUrl(reel)">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Open in new tab" (click)="openInNewTab(reel)">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </div>
        </div>

        <div class="reel-actions">
          <button mat-stroked-button (click)="openEdit(reel)">
            <mat-icon>edit</mat-icon>
            Edit
          </button>
          <button mat-icon-button color="warn" matTooltip="Delete" (click)="confirmDelete(reel)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
